import styles from './Loader.module.scss';

export const Loader = () => {
  return (
    <div className={'text-center p-5'}>
      <span className={`${styles.loader}`}></span>
    </div>
  );
};
